import React, { Suspense, useContext, useEffect, useState } from "react";
import { HashRouter, Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";

import { CSpinner, useColorModes } from "@coreui/react";
import "./scss/style.scss";
import "./layout/main/style/form/Form.css";
import "./layout/main/style/button/button.css";
import "./layout/main/style/modal/modal.css";
import "./layout/main/style/table/table.css";

// We use those styles to show code examples, you should remove them in your application.
import "./scss/examples.scss";
import { useDispatch, useSelector } from "react-redux";
import { AuthLogOut, GETAuthLogin } from "./features/auth/Slice";
import { Context } from "./utils/context";
import Dashboard from "./components/admin/dashboard/Dashboard";
import LoadingModal from "./components/common_modal/Loader_Modal/LoaderModal";
import { faL } from "@fortawesome/free-solid-svg-icons";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./components/login/Login"));
// const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./components/page404/Page404"));
const Page500 = React.lazy(() => import("./components/page500/Page500"));

const App = () => {
  const { isSidebarOpen, isAllow, signin, loading } = useContext(Context);
  const { isColorModeSet, setColorMode } = useColorModes(
    "coreui-free-react-admin-template-theme",
  );
  const settings = useSelector((state) => state.settings);

  useEffect(() => {
    if (settings.theme) {
      setColorMode(settings.theme);
    }

    if (isColorModeSet()) {
      return;
    }

    setColorMode(settings.theme);
  }, []);

  // console.log(signin, "signin");

  return (
    // <HashRouter>
    <>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        {!signin ? (
          <Login />
        ) : (
          <Routes>
            <Route exact path="/" name="Login Page" element={<Login />} />
            {/* <Route
            exact
            path="/register"
            name="Register Page"
            element={<Register />}
          />*/}

            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Routes>
        )}
      </Suspense>
      <LoadingModal show={loading} />
    </>
    // </HashRouter>
  );
};

export default App;
